import React from 'react';
import PropTypes from 'prop-types';
import { CloudSleepSvg } from '../../assets/svgs';
import { EmptyModalContainer, EmptyModalWrapper } from './empty-modal.style';

const EmptyModalComponent = ({ text, icon: Icon = CloudSleepSvg }) => {
    return (
        <EmptyModalWrapper>
            <EmptyModalContainer>
                {/* <Icon /> */}
                {
                    text &&
                    <p>{text}</p>
                }
            </EmptyModalContainer>
        </EmptyModalWrapper>
    );
};

EmptyModalComponent.propTypes = {
    icon: PropTypes.elementType,
    text: PropTypes.string,
};

export default EmptyModalComponent;
